import React from "react";
import Back from "../Assets/img/Support/support_back.png";
import Curve from "../Assets/img/Aboutus/curve.png";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const Support = () => {
	return (
		<>
			<Navbar />
			<div style={{ marginTop: "-6%" }}>
				<div
					className=""
					style={{
						backgroundImage: "url(" + Back + ")",
						backgroundSize: "cover",
					}}
				>
					<br />
					<br />
					<br />
					<br />
					<br />
					<br />
					<br />
					<br />

					<h1
						style={{ fontWeight: "Poppins-Bold", fontSize: "50px" }}
						className="text-white text-center"
					>
						Contact Us
					</h1>
					<img className="mx-auto d-block" src={Curve} />

					<br />
					<br />
					<br />
				</div>
				<div className="container">
					<br />
					<div className="row">
						<div className="col-lg-4 col-xl-4 col-sm-12 col-md-4 col-12">
							<p style={{ textAlign: "left" }}>
								Phone: <b>9492830912</b>{" "}
							</p>
							<p style={{ textAlign: "left" }}>
								Email: <b>info@cantileverlabs.com</b>{" "}
							</p>
							<br />
						</div>
						<div className="col-lg-8 col-xl-8 col-sm-12 col-md-8 col-12">
							<div className="row">
								<div className="col">
									<input
										style={{ width: "100%" }}
										type="text"
										placeholder="Name"
									/>
								</div>
								<div className="col">
									<input
										style={{ width: "100%" }}
										type="email"
										placeholder="Email"
									/>
									<br />
								</div>
							</div>
							<br />
							<input
								style={{ width: "96%" }}
								type="text"
								placeholder="Subject"
							/>
							<br />
							<br />
							<textarea
								rows="5"
								style={{ width: "96%" }}
								placeholder="Message"
							></textarea>
							<br />
							<div className="row">
								<div className="col">
									<a
										href=""
										style={{ width: "80%" }}
										className="btn btn-warning"
									>
										Submit
									</a>
								</div>
								<div className="col"></div>
							</div>
						</div>
					</div>
				</div>
				<Footer />
			</div>
		</>
	);
};

export default Support;
